export const getDetectionButtonLayoutClass = ({
  compact = false,
  wide = false,
}: {
  compact?: boolean;
  wide?: boolean;
} = {}): string => {
  if (compact) {
    return "min-h-[38px] w-full min-w-0 max-w-full overflow-hidden px-1 py-1 text-center text-[12px] leading-tight [&_svg]:h-[14px] [&_svg]:w-[14px] [&_svg]:align-middle";
  }
  return wide
    ? "w-[240px] p-1 text-[12px] [&_svg]:h-[22px] [&_svg]:w-[22px] [&_svg]:align-middle"
    : "w-[170px] p-1 text-[12px] [&_svg]:h-[22px] [&_svg]:w-[22px] [&_svg]:align-middle";
};
